import { render, staticRenderFns } from "./create-supplier.vue?vue&type=template&id=4a64b9d5&scoped=true&"
import script from "./create-supplier.vue?vue&type=script&lang=ts&"
export * from "./create-supplier.vue?vue&type=script&lang=ts&"
import style0 from "./create-supplier.vue?vue&type=style&index=0&id=4a64b9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64b9d5",
  null
  
)

component.options.__file = "create-supplier.vue"
export default component.exports